<template>
    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading"
               :filters.sync="filters" removableSort :rowsPerPageOptions="[10,25,50]" @page="scrollUp"
               responsiveLayout="scroll" class="p-datatable-striped" dataKey="id" filterDisplay="row"
               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
               currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords} Veículos">
        <template #header>
            <div class="text-right pr-4">
                <Button icon="pi pi-plus" class="p-button-success" :label="$t('AppImplementTable.Criar implemento')"
                        style="font-size: 13px" @click="add"/>
            </div>
        </template>
        <template #empty>
            {{ $t('AppImplementTable.Sem dados para este filtro') }}
        </template>
        <template #loading>
            {{ $t('AppImplementTable.Carregando implementos, por favor aguarde') }}
        </template>
        <Column field="identification" header="Identificação" headerClass="headerClass" :sortable="true"
                bodyClass="bodyClass" filterField="identification" filterMatchMode="contains"
                :showFilterMenu="false" :showClearButton="false" :styles="{'min-width':'10rem'}">
            <template #filter="{filterModel,filterCallback}">
                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                           class="p-column-filter"/>
            </template>
        </Column>
        <Column field="manufacturer_name" :header="$t('AppImplementTable.Fabricante')" headerClass="headerClass"
                filterField="manufacturer_name" filterMatchMode="contains" bodyClass="bodyClass"
                :sortable="true" :showFilterMenu="false" :showClearButton="false"
                :styles="{'min-width':'10rem'}">
            <template #filter="{filterModel,filterCallback}">
                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                           class="p-column-filter"/>
            </template>
        </Column>
        <Column field="model_name" :header="$t('AppImplementTable.Modelo')" filterField="model_name" headerClass="headerClass"
                bodyClass="bodyClass" :sortable="true" filterMatchMode="contains"
                :showFilterMenu="false" :showClearButton="false" :styles="{'min-width':'10rem'}">
            <template #filter="{filterModel,filterCallback}">
                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                           class="p-column-filter"/>
            </template>
        </Column>
        <Column field="implement_type" :header="$t('AppImplementTable.Tipo')" headerClass="headerClass" bodyClass="bodyClass" sortable
                filterField="implement_type" filterMatchMode="in" :showFilterMenu="false" :showClearButton="false"
                :styles="{maxWidth: '12rem !important', padding: '0px'}">
            <template #filter="{filterModel,filterCallback}">
                <MultiSelect v-model="filterModel.value" :options="implementTypes"
                             optionLabel="text" optionValue="value" :filter="true" appendTo="tableDiv"
                             style="width: 100%" placeholder="Selecione" @input="filterCallback()">
                </MultiSelect>
            </template>
            <template #body="slotProps">
                {{ slotProps.data.implement_type ? parseImplementType(slotProps.data.implement_type).text : null }}
            </template>
        </Column>
        <Column field="last_modified_date" :header="$t('AppImplementTable.Última alteração')" headerClass="headerClass"
                bodyClass="bodyClass" :sortable="true" filterField="last_modified_date"
                filterMatchMode="contains" :showFilterMenu="false" :showClearButton="false"
                :styles="{'min-width':'12rem'}">
            <template #body="slotProps">
                <span>{{ dateHourFormat(slotProps.data.last_modified_date) }}</span>
            </template>
            <template #filter="{filterModel,filterCallback}">
                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                           class="p-column-filter"/>
            </template>
        </Column>
        <Column field="beacon_mac_address" :header="$t('AppImplementTable.Beacon')" filterField="beacon_mac_address" headerClass="headerClass"
                bodyClass="bodyClass" :sortable="true" filterMatchMode="contains"
                :showFilterMenu="false" :showClearButton="false" :styles="{'min-width':'10rem'}">
            <template #filter="{filterModel,filterCallback}">
                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                           class="p-column-filter"/>
            </template>
        </Column>
        <Column headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width':'10rem'}">
            <template #body="slotProps">
                <div>
                    <Button icon="pi pi-eye" class="p-button-rounded p-button-warning mx-md-1 mx-0"
                            @click="view(slotProps.data)" v-tooltip.top="$t('AppImplementTable.Visualizar implemento')"/>
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-info mx-md-1 mx-0"
                            @click="edit(slotProps.data)" v-tooltip.top="$t('AppImplementTable.Editar implemento')"/>
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mx-md-1 mx-0"
                            @click="remove(slotProps.data)" v-tooltip.top="$t('AppImplementTable.Remover implemento')"/>
                </div>
            </template>
        </Column>
    </DataTable>
</template>

<script>
import {FilterMatchMode, FilterService} from "primevue/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import Button from "primevue/button";
import dateHourFormat from "@/mixins/DateMixin";
import {IMPLEMENTS_TYPES} from "@/constants/ImplementConstants";
import Tooltip from "primevue/tooltip";
const DATE_FILTER = 'DATE FILTER';
export default {
    mounted() {
        FilterService.register(DATE_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.dateHourFormat(value).includes(filter);
        });
    },
    data() {
        return {
            implementTypes: IMPLEMENTS_TYPES,
            filters: {
                'identification': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'manufacturer_name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'model_name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'implement_type': {value: null, matchMode: FilterMatchMode.IN},
                'last_modified_date': {value: null, matchMode: DATE_FILTER},
                'beacon_mac_address': {value: null, matchMode: FilterMatchMode.CONTAINS}
            },
        }
    },
    mixins: [dateHourFormat],
    methods: {
        add() {
            this.$emit('add');
        },
        edit(value) {
            this.$emit('edit', value);
        },
        view(value) {
            this.$emit('view', value);
        },
        remove(value) {
            this.$emit('remove', value);
        },
        scrollUp() {
            this.$emit('scrollUp');
        },
        parseImplementType(implementTypeCode) {
            return this.implementTypes.find(type => type.value === implementTypeCode);
        },
    },
    props: {
        selectedOrg: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        gridData: {
            type: Array,
            default: null
        }
    },
    directives: {
        tooltip: Tooltip
    },
    components: {
        DataTable,
        Column,
        InputText,
        MultiSelect,
        Button
    }
}
</script>

<style scoped>
</style>
